








import { apiClient } from "@/services/api-client";
import { saveAs } from "file-saver";
import LoadingText from "@/components/LoadingText.vue";

export default {
  name: "DocumentDownloader",
  components: { LoadingText },
  props: {
    id: {
      type: String,
      required: true
    },
    verkoopFactuurNr: {
      type: String,
      required: true
    },
    verkoopCreditNotitieNr: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    downloadFile() {
      this.loading = true;

      apiClient
        .downloadFactuurDocument({
          faktuurId: this.id,
          verkoopFactuurNr: this.verkoopFactuurNr,
          verkoopCreditNotitieNr: this.verkoopCreditNotitieNr
        })
        .then(response => response.document)
        .then(doc => {
          const dataURI = `data:application/octet-stream;charset=utf-16le;base64,${doc.base64EncodingContents}`;
          const blob = this.dataURIToBlob(dataURI);
          saveAs(blob, doc.bestandsNaam);

          this.loading = false;
        });
    },
    /**
     * Solution from: https://stackoverflow.com/a/38845151/4349566
     */
    dataURIToBlob(dataURI) {
      const binStr = atob(dataURI.split(",")[1]);
      const len = binStr.length;
      const arr = new Uint8Array(len);
      const mimeString = dataURI
        .split(",")[0]
        .split(":")[1]
        .split(";")[0];

      for (let i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
      }

      return new Blob([arr], {
        type: mimeString
      });
    }
  }
};
